/*
  Sleekpaw — Premium motion controller.
  Tiny IntersectionObserver activator for .sp-reveal classes + sticky-story
  step highlighting. Deferred. ~1KB minified. No deps.

  Skips everything if the user prefers reduced motion.
*/
(function () {
  'use strict';

  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // No-op if reduced motion is requested — the CSS already disables reveals
  // in that case via the @media block, but we also skip listeners to be tidy.
  if (prefersReducedMotion) return;

  // ---------- 1. .sp-reveal activator (one-shot, unobserve after fire) ----
  var revealNodes = document.querySelectorAll('.sp-reveal');
  if (revealNodes.length) {
    if ('IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              revealObserver.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
      );
      revealNodes.forEach(function (n) { revealObserver.observe(n); });
    } else {
      // Old browser fallback — just show everything
      revealNodes.forEach(function (n) { n.classList.add('is-visible'); });
    }
  }

  // ---------- 2. Sticky-story: highlight the step currently in view -----
  //
  // Sets .is-active on the step whose midpoint is closest to viewport center,
  // and mirrors that step's media on the sticky stage.

  var stories = document.querySelectorAll('.sp-sticky-story');
  if (!stories.length) return;

  stories.forEach(function (story) {
    var steps = story.querySelectorAll('.sp-sticky-story__step');
    var stageImgs = story.querySelectorAll('.sp-sticky-story__media-stage img');
    if (!steps.length) return;

    function setActive(idx) {
      steps.forEach(function (s, i) {
        s.classList.toggle('is-active', i === idx);
      });
      if (stageImgs.length) {
        stageImgs.forEach(function (img, i) {
          img.classList.toggle('is-active', i === idx);
        });
      }
    }

    if ('IntersectionObserver' in window) {
      // Each step reports when it's near viewport center. The most recently
      // reported wins (which works because IO fires in document order during
      // a scroll pass).
      var stepObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var idx = Array.prototype.indexOf.call(steps, entry.target);
              if (idx > -1) setActive(idx);
            }
          });
        },
        {
          // Centerline band — step is "active" when its center is in the
          // middle ~40% of the viewport.
          rootMargin: '-30% 0px -30% 0px',
          threshold: 0,
        }
      );
      steps.forEach(function (s) { stepObserver.observe(s); });
      // Activate the first step on load so the stage isn't empty
      setActive(0);
    } else {
      setActive(0);
    }
  });
})();
